import { Configuration as BaseConfiguration } from './base-api';
import { Configuration as GbConfiguration } from './gb-api';
import { Configuration as StammConfiguration } from './stammdaten-api';
import { Configuration as AVConfiguration } from './av-api';
import { Configuration as AuftragConfiguration } from './auftrag-api';
import { Configuration as GwrConfiguration } from './gwr-api';
import { Configuration as PersonConfiguration } from './personstamm-api';
import { Configuration as GrundbuchMeldungConfiguration } from './grundbuchmeldung-api';
import { Configuration as MapsConfiguration } from './maps-api';
import { Configuration as OerebConfiguration } from './oereb-api';
import { Configuration as AmtlicheBewertungConfiguration } from './amtlichebewertung-api';
import { Configuration as BatchAuftragConfiguration } from './batch-auftrag-api';
import { Configuration as AmtlichBewertungStimeConfiguration } from './amtlichebewertung-stime-api';
import { environment } from '../../environments/environment';

export function apiBaseConfigFactory() {

  return new BaseConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiGbConfigFactory() {
  return new GbConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiStammConfigFactory() {
  return new StammConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiAvConfigFactory() {
  return new AVConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiAufragConfigFactory() {
  return new AuftragConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiGwrConfigFactory() {
  return new GwrConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiPersonstammConfigFactory() {
  return new PersonConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiGrundbuchmeldungConfigFactory() {
  return new GrundbuchMeldungConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiMapsConfigFactory() {
  return new MapsConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiOerebConfigFactory() {
  return new OerebConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiAmtlichBewertungConfigFactory() {
  return new AmtlicheBewertungConfiguration({
    basePath: environment.apiUrl
  });
}

export function apiBatchAuftragConfigFactory() {
  return new BatchAuftragConfiguration({
    basePath: environment.apiUrl
  });
}

export function  apiAmtlichBewertungStimeConfigFactory() {
  return new AmtlichBewertungStimeConfiguration({
    basePath: environment.apiUrl
  });
}


